module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_5.ef88ae5d.png";